import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-12 pb-10 md:pt-20 md:pb-16 overflow-hidden bg-brand-cream" data-id="element-47">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-48">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-49">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-50">
            <div className="inline-block mb-3 px-4 py-1.5 bg-brand-lightBlue text-brand-blue font-bold rounded-full text-sm uppercase tracking-wider" data-id="element-51">
              ✈️ The "Quiet Cabin" Survival Kit
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark leading-tight mb-4" data-id="element-52">
              Stop the mid-flight meltdowns and travel in total "Zen Mode"
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-5 font-medium" data-id="element-53">
              Even if you're currently terrified of your next trip with a
              toddler.
            </p>

            <div className="bg-white p-4 rounded-2xl shadow-sm border border-orange-100 mb-6 relative" data-id="element-54">
              <div className="absolute -top-3 -left-3 text-3xl" data-id="element-55">💭</div>
              <p className="text-base italic text-gray-700 leading-relaxed" data-id="element-56">
                "You know the feeling. The 'Fasten Seatbelt' sign dings, the
                cabin pressure shifts, and your toddler hits a volume you didn't
                know was humanly possible. You feel the heat rising in your
                neck. You feel the eyes of 150 judging passengers on your back.
                You've tried the iPad, the 'new toy,' and the snacks, but
                nothing is working. You just want to teleport home."
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center" data-id="element-57">
              <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-58">
                Get the Survival Kit Now
              </Button>
              <span className="text-sm text-gray-500 font-medium" data-id="element-59">
                Instant digital delivery ⚡️
              </span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-60">
            <div className="absolute inset-0 bg-brand-blue/10 rounded-[3rem] transform rotate-3 scale-105" data-id="element-61"></div>
            <img src="https://cdn.magicpatterns.com/uploads/k2BoNvCKS3rrSAGUdrUT45/heylloyd-image-1772765482112.png" alt="Toddler Travel Survival Kit on devices" className="relative z-10 rounded-2xl shadow-2xl w-full object-cover" data-id="element-62" />
          </motion.div>
        </div>
      </div>
    </section>;
}